import { PHENO_CODES } from '../../../hooks/usePhenomenaData'

// Mřížka jev × den pro jednu stanici.
//   normal      – řádky = jevy, sloupce = dny v měsíci
//   transposed  – řádky = dny, sloupce = jevy
// Vytaženo z DlyJevyView — sdílené s rozbaleným řádkem v GroupJevyOverviewGrid (tam vždy normal).
//
// dayKeys: pole "YYYY-MM-DD" (buildDayKeys)
// defsMap: Map<code, { name, svg }>
// dayMap:  Map<"YYYY-MM-DD", Set<code>>
export function PhenomenaDayGrid({ dayKeys, defsMap, dayMap, orientation = 'normal' }) {
  if (orientation === 'transposed') {
    return (
      <div className="overflow-auto border border-gray-200">
        <table className="border-separate border-spacing-0 border-l-2 border-l-gray-400 border-r-2 border-r-gray-400 border-b-2 border-b-gray-400 text-xs table-fixed">
          <colgroup>
            <col className="w-12" />
            {PHENO_CODES.map(code => <col key={code} className="w-8" />)}
          </colgroup>
          <thead className="sticky top-0 z-20">
            <tr>
              <th className="sticky left-0 z-10 bg-gray-50 border-t-2 border-t-gray-400 border-b border-b-gray-400 border-r border-r-gray-400 px-2 py-1.5 text-center text-xs font-semibold text-gray-500">
                Den
              </th>
              {PHENO_CODES.map(code => {
                const def = defsMap.get(code)
                return (
                  <th key={code} className="bg-gray-50 border-t-2 border-t-gray-400 border-b border-b-gray-400 border-r border-r-gray-200 px-1 py-1.5 text-center text-xs font-normal text-gray-500" title={def?.name ?? code}>
                    <div className="flex flex-col items-center gap-0.5">
                      {def?.svg && <span className="inline-block w-4 h-4" dangerouslySetInnerHTML={{ __html: def.svg }} />}
                      <span>{code}</span>
                    </div>
                  </th>
                )
              })}
            </tr>
          </thead>
          <tbody>
            {dayKeys.map((key, idx) => {
              const d = new Date(key + 'T00:00:00Z')
              const present = dayMap.get(key) ?? new Set()
              const isStriped = idx % 2 === 1
              return (
                <tr key={key} className={isStriped ? 'bg-gray-50' : 'bg-white'}>
                  <td className="sticky left-0 z-10 px-2 py-1 border-b border-b-gray-200 border-r border-r-gray-400 bg-inherit text-center font-semibold text-gray-600">
                    {d.getUTCDate()}.
                  </td>
                  {PHENO_CODES.map(code => {
                    const def = defsMap.get(code)
                    const has = present.has(code)
                    return (
                      <td key={code} className="px-1 py-1 border-b border-b-gray-200 border-r border-r-gray-200 text-center">
                        {has && def?.svg && (
                          <span
                            className="inline-block w-4 h-4"
                            dangerouslySetInnerHTML={{ __html: def.svg }}
                            title={def.name ?? code}
                          />
                        )}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <div className="overflow-auto border border-gray-200">
      <table className="border-separate border-spacing-0 border-l-2 border-l-gray-400 border-r-2 border-r-gray-400 border-b-2 border-b-gray-400 text-xs table-fixed">
        <colgroup>
          <col className="w-12" />
          {dayKeys.map(key => <col key={key} className="w-8" />)}
        </colgroup>
        <thead className="sticky top-0 z-20">
          <tr>
            <th className="sticky left-0 z-10 bg-gray-50 border-t-2 border-t-gray-400 border-b border-b-gray-400 border-r border-r-gray-400 px-2 py-1.5 text-center text-xs font-semibold text-gray-500">
              Jev
            </th>
            {dayKeys.map(key => {
              const d = new Date(key + 'T00:00:00Z')
              return (
                <th key={key} className="bg-gray-50 border-t-2 border-t-gray-400 border-b border-b-gray-400 border-r border-r-gray-200 px-1 py-1.5 text-center text-xs font-normal text-gray-500">
                  {d.getUTCDate()}.
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {PHENO_CODES.map((code, idx) => {
            const def = defsMap.get(code)
            const isStriped = idx % 2 === 1
            return (
              <tr key={code} className={isStriped ? 'bg-gray-50' : 'bg-white'}>
                <td className="sticky left-0 z-10 px-2 py-1 border-b border-b-gray-200 border-r border-r-gray-400 bg-inherit text-center">
                  <span className="font-semibold text-gray-600" title={def?.name}>{code}</span>
                </td>
                {dayKeys.map(key => {
                  const present = dayMap.get(key) ?? new Set()
                  const has = present.has(code)
                  return (
                    <td key={key} className="px-1 py-1 border-b border-b-gray-200 border-r border-r-gray-200 text-center">
                      {has && def?.svg && (
                        <span
                          className="inline-block w-4 h-4"
                          dangerouslySetInnerHTML={{ __html: def.svg }}
                          title={def.name ?? code}
                        />
                      )}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
